import TicketTypeEdit from './TicketTypeEdit';

export default TicketTypeEdit;
